import React, { FormEvent, useState } from "react";
import classes from "./index.module.scss";
import { Button, Input, Modal } from "antd";
import classNames from "classnames";

export type StatusType = "all" | "sign" | "unSign";

export interface FilterValue {
    status: StatusType; // 全部/已签到/未签到
    text: string;
}

interface SignInFilterProps {
    courseStuCount: number;
    signInStuCount: number;
    notSingInStuCount: number;
    filter: FilterValue;
    onChange: (val: FilterValue) => void;
    onSignAll(): Promise<void>;
}

export default function SignInFilter({
    courseStuCount,
    notSingInStuCount,
    signInStuCount,
    filter,
    onChange,
    onSignAll
}: SignInFilterProps) {
    const [text, setText] = useState("");

    function signAll() {
        Modal.confirm({
            content: "确定要把所有学生标记为'出勤'吗?",
            onOk: async () => {
                try {
                    await onSignAll();
                } catch (e) {
                    Modal.error({ content: "签到失败" });
                }
            }
        });
    }

    function onConfirmSearch(e: FormEvent) {
        e.preventDefault();
        onChange({ status: filter.status, text: text.trim() });
    }

    // 点击统计数字
    function onClickStatic(status: StatusType) {
        onChange({ status, text: text.trim() });
    }

    return (
        <div className={classes.root}>
            <div className={classes.left}>
                <div
                    className={classNames(classes.statics, {
                        [classes.active]: filter.status === "all"
                    })}
                    onClick={() => onClickStatic("all")}>
                    <em>{courseStuCount}</em>课程人数
                </div>
                <div
                    className={classNames(classes.statics, {
                        [classes.active]: filter.status === "sign"
                    })}
                    onClick={() => onClickStatic("sign")}>
                    <em>{signInStuCount}</em>已签到
                </div>
                <div
                    className={classNames(classes.statics, {
                        [classes.active]: filter.status === "unSign"
                    })}
                    onClick={() => onClickStatic("unSign")}>
                    <em>{notSingInStuCount}</em>未签到
                </div>
            </div>

            <form className={classes.filter} onSubmit={onConfirmSearch}>
                <Input
                    className={classes.input}
                    placeholder="请输入姓名、学号查看学生签到状态"
                    onChange={e => setText(e.target.value)}
                />

                <Button
                    htmlType="submit"
                    type="primary"
                    className={classes.searchBtn}>
                    查询
                </Button>

                <Button
                    type="primary"
                    ghost
                    className={classes.checkAllButton}
                    onClick={signAll}>
                    一键更新为出勤
                </Button>
            </form>
        </div>
    );
}
